export const MODULE_NAME = 'library';
